// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__38AJy","detailsBorder":"styles_detailsBorder__2Ki5j"};